import ProfileDropdown, { IProfileDropdownProps, ProfileLinks } from './ProfileDropdown.component';
import ProfileDropdownWrapper from './ProfileDropdown.wrapper';

export default ProfileDropdownWrapper;
export { ProfileDropdown, ProfileLinks };
export type { IProfileDropdownProps };
